<template>
  <div>
    <v-btn icon @click="isDialog = true" :disabled="(value && value.length ? false : true) || disableIcon">
      <v-icon>mdi-table-cog</v-icon>
    </v-btn>
    <v-dialog v-model="isDialog" max-width="900" v-if="value && value.length">
      <v-card loader-height="10">
        <v-card-title class="space-between">
          <div class="no-b">{{ $t('project.manage_column_in_table') }}<div class="b">{{ subHeader }}</div>
          </div>
          <v-btn icon @click="isDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="sub-title">
            <div>{{ $t('project.select_to_show_or_hide_data') }}</div>
            <v-chip color="success" outlined icon @click="selectFunction('all')"><v-icon>mdi-check-all</v-icon>{{
              $t('select_all') }}</v-chip>
            <v-chip color="error" outlined icon
              @click="selectFunction('first')"><v-icon>mdi-close-circle-multiple-outline</v-icon>{{ $t('reset')
              }}</v-chip>
          </div>
          <v-chip-group column multiple v-model="isShowHeaders">
            <v-chip color="info" filter outlined v-for="header of value"
              :key="`v-chip-filter-table-${dataTableName}-${header.value}`" :value="header.value">
              {{ header.text }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div v-show="isShowHeaders.length <= 1" class="red-text">
            {{ $t('validate.must_select_at_least_one') }}
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="isDialog = false"> {{ $t('close') }} </v-btn>
          <v-btn color="success" @click="onSuccess()"> {{ $t('save') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "FilterColumnDataTable",
  props: {
    value: Array,
    dataTableName: String,
    disableIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subHeader() {
      let text = ''
      if (this.dataTableName && this.subHeaderLabels && this.subHeaderLabels[this.dataTableName]) text = this.subHeaderLabels[this.dataTableName].text
      return text
    }
  },
  watch: {
    isDialog(isDialog) {
      if (isDialog) {
        this.initData()
      } else {

      }
    }
  },
  data() {
    return {
      isDialog: false,
      isShowHeaders: [],
      subHeaderLabels: {
        ReportActive: {},
        ReportInvoice: {},
        ReportAudit: {},
        ReportBooking: {},
        ReportCashback: {},
        ReportCheckin: {},
        ReportCheckout: {},
      },
      localStorageItems: null
    };
  },
  created() {
    this.subHeaderLabels = {
      ReportActive: { text: this.$t('customer.current_customer') },
      ReportInvoice: { text: this.$t('payment.unpaid_payment_list') },
      ReportAudit: { text: this.$t('edit_history') },
      ReportBooking: { text: this.$t('booking.booking') },
      ReportCashback: { text: this.$t('payment.deposit_refund_list') },
      ReportCheckin: { text: this.$t('customer.customer_move_in') },
      ReportCheckout: { text: this.$t('customer.customer_checkout') },
    }
  },
  methods: {
    initData() {
      this.localStorageItems = localStorage.getItem("filterDataTable");
      if (this.localStorageItems) this.localStorageItems = JSON.parse(this.localStorageItems)
      if (!this.localStorageItems || (this.localStorageItems && (!this.localStorageItems[this.dataTableName] || this.localStorageItems[this.dataTableName].length == 0))) {
        if (!this.localStorageItems) this.localStorageItems = {}
        this.localStorageItems[this.dataTableName] = this.value && this.value.length ? this.value.filter(h => h.isShow).map(h => h.value) : []
        localStorage.setItem("filterDataTable", JSON.stringify(this.localStorageItems));
      }

      if (this.localStorageItems && this.localStorageItems[this.dataTableName])
        this.isShowHeaders = this.localStorageItems[this.dataTableName]
    },
    onSuccess() {
      // let headers = this.value
      // for (let header of headers) {
      //   header.isShow = this.isShowHeaders.find(h => h == header.value) ? true : false;
      // }
      if (this.dataTableName && this.localStorageItems && this.localStorageItems[this.dataTableName] && this.isShowHeaders && this.isShowHeaders.length) {
        this.localStorageItems[this.dataTableName] = this.isShowHeaders
        localStorage.setItem("filterDataTable", JSON.stringify(this.localStorageItems));
      }
      this.isDialog = false
      this.$emit("onSuccess");
    },
    selectFunction(select) {
      if (select == 'all') {
        this.isShowHeaders = this.value && this.value.length ? this.value.map(h => h.value) : []
      } else if (select == 'first') {
        this.isShowHeaders = this.value && this.value.length ? [this.value[0].value] : []
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-title {
  display: flex;
  gap: 10px;
  margin: 15px;

  .v-icon {
    margin-right: 5px;
  }
}

.no-b {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-weight: 400;

  .b {
    font-weight: bold;
  }
}
</style>